import React, { useEffect, useState } from 'react';
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Table,
  InputGroup,
  Spinner,
} from 'react-bootstrap';
import Select from 'react-select';
import { getMainProduct, getSubProduct } from '../../../API/Service/bulkPriceService';

const allProducts = {
  mobiles: [
    { id: 1, name: 'iPhone 14', mrp: 90000, price: 85000 },
    { id: 2, name: 'Samsung S22', mrp: 70000, price: 68000 },
  ],
  accessories: [
    { id: 3, name: 'Charger', mrp: 2000, price: 1800 },
    { id: 4, name: 'Headphones', mrp: 5000, price: 4500 },
  ],
  laptops: [
    { id: 5, name: 'MacBook Pro', mrp: 150000, price: 145000 },
    { id: 6, name: 'Dell XPS', mrp: 120000, price: 115000 },
  ],
};

const BulkPricePage = () => {
  const [mainProductOptions, setMainProductOptions] = useState([]);
  const [selectedSubProduct, setSelectedSubProduct] = useState(null);
  const [productList, setProductList] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false); // ✅ loader state

  const handleSubProductChange = (option) => {
    setSelectedSubProduct(option);
    setProductList(allProducts[option.value] || []);
    setSearchTerm('');
  };

  const handleValueChange = (id, field, value) => {
    setProductList((prev) =>
      prev.map((prod) =>
        prod.id === id ? { ...prod, [field]: Number(value) } : prod
      )
    );
  };

  const handleSubmit = () => {
    console.log('Submitted:', productList);
    alert('Prices submitted!');
  };

  const filteredList = allProducts.filter((prod) =>
    prod?.subpname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const fetchMainProduct = async () => {
      try {
        const data = await getMainProduct();
        const formatted = data?.data?.map((item) => ({
          value: item.id,
          label: item.mpname,
        }));
        setMainProductOptions(formatted);
      } catch (error) {
        alert(error.message);
      }
    };

    fetchMainProduct();
  }, []);

  useEffect(() => {
    if (selectedSubProduct === null) return;
    const fetchSubProduct = async () => {
      try {
        setLoading(true); // ✅ show loader
        const data = await getSubProduct({ mpid: selectedSubProduct?.value });
        const extractedData = data?.data?.map((item) => {
          const firstSize = item.sizeProductSet?.[0] || {};
          return {
            id: item.id,
            subpname: item.subpname,
            mrp: firstSize.ps_mrp ?? null,
            price: firstSize.ps_price ?? null,
          };
        });
        setAllProducts(extractedData);
      } catch (error) {
        alert(error.message);
      } finally {
        setLoading(false); // ✅ hide loader
      }
    };

    fetchSubProduct();
  }, [selectedSubProduct]);

  return (
    <Container className="py-3">
      <Card className="shadow-sm border-0">
        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Bulk Price Update</h5>
            <Button size="sm" variant="success" onClick={handleSubmit}>
              Submit
            </Button>
          </div>

          <Row className="mb-3">
            <Col md={4} sm={6}>
              <Form.Label className="mb-1">Sub Product</Form.Label>
              <Select
                options={mainProductOptions}
                onChange={handleSubProductChange}
                placeholder="Select..."
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '30px',
                    fontSize: '0.85rem',
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: '0 6px',
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    padding: '0 6px',
                  }),
                }}
              />
            </Col>

            {allProducts?.length > 0 && !loading && (
              <Col md={4} sm={6} className="ms-auto text-end">
                <Form.Label className="mb-1">Search</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="Search by product name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Col>
            )}
          </Row>

          {/* ✅ Show spinner when loading */}
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : filteredList.length > 0 ? (
            <div style={{ overflowX: 'auto' }}>
              <Table bordered hover size="sm" className="align-middle">
                <thead className="table-light text-center">
                  <tr>
                    <th style={{ width: '50%' }}>Product Name</th>
                    <th style={{ width: '25%' }}>MRP (₹)</th>
                    <th style={{ width: '25%' }}>Price (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((prod) => (
                    <tr key={prod.id}>
                      <td>{prod.subpname}</td>
                      <td>
                        <InputGroup size="sm">
                          <InputGroup.Text>₹</InputGroup.Text>
                          <Form.Control
                            type="number"
                            value={prod.mrp}
                            onChange={(e) =>
                              handleValueChange(prod.id, 'mrp', e.target.value)
                            }
                          />
                        </InputGroup>
                      </td>
                      <td>
                        <InputGroup size="sm">
                          <InputGroup.Text>₹</InputGroup.Text>
                          <Form.Control
                            type="number"
                            value={prod.price}
                            onChange={(e) =>
                              handleValueChange(prod.id, 'price', e.target.value)
                            }
                          />
                        </InputGroup>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : null}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default BulkPricePage;
